package com.appcreator.blueprint.components

import com.appcreator.blueprint.core.Component
import com.appcreator.blueprint.core.ComponentClass
import com.appcreator.blueprint.core.InputProperty
import com.appcreator.blueprint.core.SkipSwiftGeneration
import com.appcreator.blueprint.core.properties.ComponentReference
import com.appcreator.blueprint.core.properties.DataPath
import com.appcreator.blueprint.spec.inputs.DataSpecType
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("EnvComponent")
@SkipSwiftGeneration
@ComponentClass(
    group = "Other",
    title = "EnvComponent",
    description = "Should only be used with Reference Components",
    availableFrom = "0.0.1"
)
data class EnvComponent(

    override val _nodeId: String?,
    override val _nodeLabel: String?,
    override val _nodeRelativeId: String?,

    @InputProperty(
        title = "Content",
        dataOptions = DataSpecType.Component,
        availableFrom = "0.0.1"
    )
    val content: DataPath?,

): Component

